import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import StudentLayout from "@/components/StudentLayout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/Home";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import Lesson from "@/pages/Lesson";
import Puzzles from "@/pages/Puzzles";
import Progress from "@/pages/Progress";
import Journey from "@/pages/Journey";
import Subscription from "@/pages/Subscription";
import Profile from "@/pages/Profile";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

import AdminOverview from "@/pages/admin/AdminOverview";
import AdminCourses from "@/pages/admin/AdminCourses";
import AdminLessons from "@/pages/admin/AdminLessons";
import AdminPuzzles from "@/pages/admin/AdminPuzzles";
import AdminStudents from "@/pages/admin/AdminStudents";
import AdminSubscriptions from "@/pages/admin/AdminSubscriptions";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/entrar" element={<Login />} />
              <Route path="/criar-conta" element={<Register />} />
              <Route path="/esqueci-senha" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />

              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

              <Route element={<ProtectedRoute><StudentLayout /></ProtectedRoute>}>
                <Route path="/painel" element={<Dashboard />} />
                <Route path="/cursos" element={<Courses />} />
                <Route path="/cursos/:id" element={<CourseDetail />} />
                <Route path="/aula/:id" element={<Lesson />} />
                <Route path="/puzzles" element={<Puzzles />} />
                <Route path="/meu-progresso" element={<Progress />} />
                <Route path="/minha-jornada" element={<Journey />} />
                <Route path="/assinatura" element={<Subscription />} />
                <Route path="/perfil" element={<Profile />} />
              </Route>

              <Route element={<ProtectedRoute adminOnly><AdminLayout /></ProtectedRoute>}>
                <Route path="/admin" element={<AdminOverview />} />
                <Route path="/admin/cursos" element={<AdminCourses />} />
                <Route path="/admin/aulas" element={<AdminLessons />} />
                <Route path="/admin/puzzles" element={<AdminPuzzles />} />
                <Route path="/admin/alunos" element={<AdminStudents />} />
                <Route path="/admin/assinaturas" element={<AdminSubscriptions />} />
                <Route path="/admin/configuracoes" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
